
import React, {Component} from 'react'
import _ from 'lodash';

class TagsInput extends Component {

    constructor(props) {
        super(props);

        this.onClickLeftButton = this.onClickLeftButton.bind(this);
        this.onClickRightButton = this.onClickRightButton.bind(this);
        this.onTagsInputChange =  this.onTagsInputChange.bind(this);
        this.onTextViewChange = this.onTextViewChange.bind(this);
    }

    componentDidMount() {
    }


    onClickLeftButton() {
        this.props.onClickLeftButton();
    }

    onClickRightButton() {
        this.props.onClickRightButton();
    }

    onTagsInputChange(e) { 
        const tags = _.split(e.target.value, ',');
        this.props.onTagsInputChange(tags);
    }

    onTextViewChange(e) {
        const contents = _.split(e.target.value, '\n');
        this.props.onTextViewChange(contents);
    }

    render() {
        return (
            <div className='container'>
                
                <div className='mt-3'>
                    <h3>{this.props.title}</h3>
                    <textarea className="text-view"
                        name=""
                        id=""
                        cols='88'
                        rows="10"
                        onChange={ this.onTextViewChange }>
                    </textarea>
                </div>
                <div className="input-group mt-3 col-md-8">
                    <input type="text"
                    className="form-control"
                    placeholder="多tag请用英文逗号(,)分隔"
                    aria-label="tag"
                    onChange={ this.onTagsInputChange } />
                    <div className="input-group-append">
                        <button
                            className="btn btn-outline-secondary"
                            type="button"
                            onClick={ this.onClickLeftButton }>Remove</button>
                        <button
                            className="btn btn-info"
                            type="button"
                            onClick={ this.onClickRightButton }>Add</button>
                        { this.props.actions }
                    </div>
                </div>
            </div>
        );
    }
}

export default TagsInput;